<template>
    <div>
        <div v-if="masechtot">
            <div class="content">
                <jabra-breadcrumbs></jabra-breadcrumbs>
                <div class="store-area">
                    <div class="description-section">
                        <div class="header">{{l10nDigitalTalmud}}</div>
                        <div class="divider"></div>
                        <span class="product-price-per-item">
                            <span class="price">15$</span>
                            <span class="between">/</span>
                            <span>{{l10nPerDaf}}</span>
                        </span>
                        <div class="description-text">
                            <span>{{l10nChoosePageMultiplePagesOrMasechet}}</span>
                        </div>
                        <div class="download-text">
                            <span>{{l10nAndDownloadAPdfFileToYourPc}}</span>
                        </div>
                        <div class="see-example">
                            <jabra-btn>
                                <span class="see-example-span">{{l10nSeeExample}}</span>
                            </jabra-btn>
                        </div>
                    </div>
                    <div class="action-section">
                        <div class="select-section">
                            <div class="select-header">
                                <span>{{l10nSelectMasechet}}</span>
                            </div>
                            <div class="select-area">
                                <div v-if="dropdownMasechtot">
                                    <div class="dropdown-container">
                                        <jabra-dropdown :data="dropdownMasechtot"
                                                        :initial-selected-item="initialMasechetName"
                                                        v-on:jbr-select="selectMasechet($event)"
                                                        :mode="MASECHET_MODE"></jabra-dropdown>
                                    </div>
                                </div>
                                <div class="radio-area">
                                    <div>
                                        <div>
                                            <label class="container">
                                                <input type="radio" name="radio" v-model="radioSelection"
                                                       value="choose">
                                                <span class="label-text">{{l10nChoosePagesFromTheMasechet}}</span>
                                                <span class="checkmark"></span>
                                            </label>
                                            <div v-if="isChooseRadioSelected">
                                                <div>
                                                    <table class="choose-pages-table">
                                                        <tr v-for="row in numOfRows" :key="row">
                                                            <td v-for="column in numOfColumns" :key="column"
                                                                v-on:click="togglePage(computePage(row, numOfColumns - column + 1))"
                                                                v-bind:class="{
                                                                    'enabled':computePage(row, numOfColumns - column + 1) !== '',
                                                                    'selected':isPageSelected(computePage(row, numOfColumns - column + 1))
                                                                }"
                                                            >
                                                                <span>{{computePage(row, numOfColumns - column + 1) | numToHebrewLetter}}</span>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                    <div class="total-price-container">
                                                        <span class="total-price">
                                                            <span>{{pages.length}} {{l10nPages}} / {{pages.length * pricePerDaf | currency}}</span>
                                                            <span></span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="radio-spacer"></div>
                                        <div class="flex-radio">
                                            <label class="container">
                                                <input type="radio" name="radio" v-model="radioSelection" value="full">
                                                <span class="label-text">{{l10nFullMasechet}}</span>
                                                <span class="checkmark"></span>
                                            </label>
                                            <span v-bind:style="{'width':'100px'}"></span>
                                            <span class="product-price">
                                                <span class="price">15$</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="add-to-cart-section">
                            <jabra-btn dark v-on:jbr-click="addToCart()" :disabled="isAddToCartDisabled">
                                <span class="add-to-cart-span">{{l10nAddToCart}}</span>
                            </jabra-btn>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
    import {
        LOAD_TALMUD_PRODUCTS,
        ADD_TO_CART,
        ADD_MULTIPLE_TO_CART,
        LOADING_COMPLETED_SUCCESS,
        READ_AND_CLEAR_PRESELECTED_DAF,
        MASECHET_MODE,
        CATEGORY_DIGITAL_TALMUD,
    } from '../services/constants'
    import helpers from '../services/helpers'
    import http from '../services/axios'

    const CHOOSE = 'choose'
    export default {
        name: 'store-digital-item-component',
        data: function () {
            return {
                radioSelection: CHOOSE,
                selectedMasechet: null,
                pages: [],
            }
        },
        computed: {
            masechtot() {
                return this.$store.state.masechtot
            },
            lessons() {
                return this.$store.state.masechtot
            },
            language() {
                return this.$store.state.languageModule.currentLanguage
            },
            initialMasechetName() {
                let masechetId = this.$route.params.masechetId
                if (masechetId) {
                    masechetId = Number(masechetId)
                }
                const result = this.masechtot.data.find(masechet => {
                    return masechet.id === masechetId
                })
                return result ? result.name : null
            },
            dropdownMasechtot() {
                if (this.masechtot.state === LOADING_COMPLETED_SUCCESS) {
                    return this.masechtot.data.map(masechet => {
                        return masechet.name
                    })
                } else {
                    return null
                }
            },
            numOfColumns() {
                return 6
            },
            numOfRows() {
                if (this.selectedMasechet) {
                    const numPages = this.selectedMasechet.pages
                    const remainder = numPages % this.numOfColumns;
                    let numRows = Math.floor(numPages / this.numOfColumns);
                    if (remainder > 0) {
                        numRows++
                    }
                    return numRows
                } else {
                    return 0
                }
            },
            pricePerDaf() {
                return 0.5
            },
            isAddToCartDisabled() {
                if (this.radioSelection === CHOOSE) {
                    return this.pages.length === 0
                }
                return false
            },
            chooseValue() {
                return CHOOSE
            },
            MASECHET_MODE() {
                return MASECHET_MODE
            },
            isChooseRadioSelected() {
                return this.radioSelection === CHOOSE
            },
            masechetNamePrefix() {
                return this.$store.state.commerceModule.masechetNamePrefix
            },
            dafNamePrefix() {
                return this.$store.state.commerceModule.dafPrefix
            },
            allOfMasechet() {
                return this.$store.state.commerceModule.allOfMasechet
            },
            l10nDigitalTalmud() {
                return this.l10nGetter('digital_talmud')
            },
            l10nPerDaf() {
                return this.l10nGetter('per_daf')
            },
            l10nChoosePageMultiplePagesOrMasechet() {
                return this.l10nGetter('choose_page_multiple_pages_or_masechet')
            },
            l10nAndDownloadAPdfFileToYourPc() {
                return this.l10nGetter('and_download_a_pdf_file_to_your_pc')
            },
            l10nSeeExample() {
                return this.l10nGetter('see_example')
            },
            l10nSelectMasechet() {
                return this.l10nGetter('select_masechet')
            },
            l10nChoosePagesFromTheMasechet() {
                return this.l10nGetter('choose_pages_from_the_masechet')
            },
            l10nPages() {
                return this.l10nGetter('pages')
            },
            l10nFullMasechet() {
                return this.l10nGetter('full_masechet')
            },
            l10nAddToCart() {
                return this.l10nGetter('add_to_cart')
            },
        },
        watch: {
            language(newVal) {
                this.init()
            }
        },
        methods: {
            selectMasechet(masechetName) {
                this.selectedMasechet = this.masechtot.data.find(masechet => {
                    return masechet.name === masechetName
                })
                this.pages = []
            },
            isPageSelected(index) {
                return this.pages.indexOf(index) > -1
            },
            togglePage(page) {
                if (page) {
                    const i = this.pages.indexOf(page)
                    if (i === -1) {
                        this.pages.push(page)
                    } else {
                        this.pages.splice(i, 1)
                    }
                }
            },
            computePage(rowNum, columnNum) {
                let num = (rowNum - 1) * this.numOfColumns + columnNum
                if (num <= this.selectedMasechet.pages) {
                    return num + 1
                } else {
                    return ''
                }
            },
            addToCart() {
                const defaultItem = CATEGORY_DIGITAL_TALMUD
                const defaultQuantity = 1
                if (this.radioSelection !== CHOOSE) {
                    const productForCart = {
                        productId: this.selectedMasechet.id,
                        item: defaultItem,
                        name: `${this.masechetNamePrefix} ${this.selectedMasechet.name}`,
                        variant: this.allOfMasechet,
                        unitPrice: this.pricePerDaf,
                        quantity: defaultQuantity,
                    }
                    this.$store.dispatch(ADD_TO_CART, productForCart)
                } else {
                    http.all(this.pages.map(page => {
                        return http
                            .getDelivery(`entries?contentType=lesson&&masechet=${this.selectedMasechet.id}&daf=${page}`)
                    })).then(responses => {
                        return responses.map(response => {
                            if (Array.isArray(response.data) && response.data.length > 0) {
                                const lesson = helpers.mapEntry(response.data[0])
                                return {
                                    productId: lesson.id,
                                    item: defaultItem,
                                    name: `${this.masechetNamePrefix} ${this.selectedMasechet.name}`,
                                    variant: `${this.dafNamePrefix} ${helpers.numToHebrewLetter(lesson.daf)}`,
                                    unitPrice: this.pricePerDaf,
                                    quantity: defaultQuantity,
                                }
                            } else {
                                return {
                                    productId: 'unknownId',
                                    item: defaultItem,
                                    name: `${this.masechetNamePrefix} ${this.selectedMasechet.name}`,
                                    variant: 'unknown',
                                    unitPrice: this.pricePerDaf,
                                    quantity: defaultQuantity,
                                }
                            }
                        })
                    }).then(products => {
                        this.$store.dispatch(ADD_MULTIPLE_TO_CART, products)
                    })
                }
            },
            init() {
                if (this.language) {
                    this.$store.dispatch(LOAD_TALMUD_PRODUCTS)
                }
                this.$store.dispatch(READ_AND_CLEAR_PRESELECTED_DAF).then(daf => {
                    if (daf) {
                        this.pages.push(daf)
                    }
                })
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            }
        },
        filters: {
            currency(value) {
                const wholeAmount = Math.floor(value)
                const fractionalAmount = (value - wholeAmount).toFixed(1).toString().slice(2)
                return `${wholeAmount}.${fractionalAmount}$`
            }
        },
        mounted() {
            this.init()
        },
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 70px 245px 75px;
    }

    .header {
        text-transform: uppercase;
        @include font-abraham(50px, $font-color-blue, 400);
    }

    .divider {
        width: 120px;
        height: 8px;
        margin: 21px 0 36px 0;
        background: $accent-1;
    }

    .store-area {
        width: 100%;
        display: flex;
        justify-content: space-around;
        margin: 30px 0 0 0;
    }

    .product-price-per-item {
        background: $accent-2;
        padding: 0 15px;
        @include font-abraham(26px, $font-color-blue, 300);
        .price {
            @include font-abraham(30px, $font-color-blue, 500);
        }

        .between {
            padding: 0 3px;
        }
    }

    .description-text {
        margin: 44px 0;
        @include font-abraham(24px, $font-color-blue, 300);
        max-width: 70%;
    }

    .download-text {
        margin: 0 0 70px 0;
        @include font-abraham(30px, $font-color-blue, 300);
        max-width: 70%;
    }

    .see-example-span {
        font-size: 24px;
        line-height: 50px;
        padding: 0 50px;
    }

    .action-section {
        background: $accent-2-alpha;
        padding: 50px 230px 90px 120px;
    }

    .select-section {

    }

    .select-header {
        @include font-abraham(16px, $grey-1, 400);
        padding: 15px 0;
    }

    .dropdown-container {
        margin: 0 0 30px 0;
    }

    .radio-area {
        .container {
            display: block;
            position: relative;
            padding-left: 35px;
            margin-bottom: 12px;
            cursor: pointer;
            font-size: 22px;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
        }

        /* Hide the browser's default radio button */
        .container input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
        }

        .label-text {
            @include font-abraham(24px, #aaaaaa, 300);
        }

        /* Create a custom radio button */
        .checkmark {
            position: absolute;
            top: 0;
            left: 0;
            height: 25px;
            width: 25px;
            border: #aaaaaa solid 1px;
            border-radius: 50%;
        }

        /* On mouse-over, add a grey background color */
        .container:hover input ~ .checkmark {
            background-color: white;
            border: $font-color-blue solid 1px;

        }

        /* When the radio button is checked*/
        .container input:checked ~ .checkmark {
            background-color: white;
            border: $font-color-blue solid 1px;
        }

        .container input:checked ~ .label-text {
            @include font-abraham(24px, $font-color-blue, 300);
        }

        /* Create the indicator (the dot/circle - hidden when not checked) */
        .checkmark:after {
            content: "";
            position: absolute;
            display: none;
        }

        /* Show the indicator (dot/circle) when checked */
        .container input:checked ~ .checkmark:after {
            display: block;
        }

        /* Style the indicator (dot/circle) */
        .container .checkmark:after {
            top: 4px;
            left: 4px;
            width: 17px;
            height: 17px;
            border-radius: 50%;
            background: $font-color-blue;
        }

        .radio-spacer {
            height: 54px;
        }

        .flex-radio {
            display: flex;
        }
    }

    table.choose-pages-table {
        border-collapse: collapse;
        border: $font-color-blue solid 1px;
        width: 100%;
        @include font-abraham(20px, $font-color-blue, 400);
        td {
            padding: 0 20px;
            border: $font-color-blue solid 1px;
            text-align: center;
            line-height: 40px;
            &.enabled {
                cursor: pointer;
                &:hover {
                    background: white;
                }
            }

            &.selected {
                background: white;
                @include font-abraham(20px, $font-color-blue, 500);
            }
        }
    }

    .total-price-container {
        margin: 40px 0;
        display: flex;
        justify-content: flex-end;
    }

    .total-price {
        background: $accent-2;
        padding: 0 15px;
        @include font-abraham(28px, $font-color-blue, 400);
    }

    .product-price {
        background: $accent-2;
        padding: 0 15px;
        @include font-abraham(26px, $font-color-blue, 300);
        .price {
            @include font-abraham(30px, $font-color-blue, 500);
            padding: 0 100px 0 0;
        }
    }

    .add-to-cart-section {
        padding: 38px 0 0 0;
    }

    .add-to-cart-span {
        font-size: 20px;
        line-height: 50px;
        padding: 0 30px;
    }

</style>
